<template>
  <b-container class="text-center">
    <label class="text-muted" v-html="$props.text"></label>
    <b-form-input v-for="(item, index) in list"
                  :key="index"
                  size="1"
                  max="1"
                  value=""
                  type="text"
                  class="text-center font-weight-bold rounded-circle mr-2"
                  autocomplete="off"
                  @keyup="moveToNextInput(index, $event)"
                  @paste="pasteHandler"
                  style="width: 3rem;max-width: 3rem;font-size: 1.5rem;display:inline;"
                  ref="inputs">
    </b-form-input>
  </b-container>
</template>
<script>
export default {
  name: 'InputOTP',
  components: {},
  data () {
    return {
      list: [],
      code: ''
    }
  },
  props: {
    text: String,
    digits: Number
  },
  mounted () {
    const firstInput = this.$refs.inputs[0]
    firstInput.focus()
  },
  methods: {
    // METHOD TO VALIDATE EMAIL
    getFullCode () {
      return this.code
    },
    moveToNextInput (index, event) {
      if (event.key === 'Backspace') {
        this.moveToPrevInput(index)
      } else {
        const nextInput = this.$refs.inputs[index + 1]
        this.concatCode()
        if (nextInput) {
          nextInput.focus()
        } else if (index === this.digits - 1) {
          this.$emit('complete', this.code)
        }
      }
    },
    moveToPrevInput (index) {
      const prevInput = this.$refs.inputs[index - 1]
      this.concatCode()
      if (prevInput) {
        prevInput.focus()
      }
    },
    pasteHandler (event) {
      const pastedText = event.clipboardData.getData('text')
      let index = 0
      setTimeout(() => {
        for (const char of pastedText) {
          if (index < this.digits) {
            this.$refs.inputs[index].$el.value = char
            this.code = this.code + char
            index++
          }
        }
        // MOVE TO THE LAST INPUT
        this.$refs.inputs[this.digits - 1].focus()
      }, 0)
    },
    concatCode () {
      this.code = ''
      for (let i = 0; i < this.digits; i++) {
        this.code = this.code + this.$refs.inputs[i].$el.value
      }
    }
  },
  beforeMount () {
    for (let i = 1; i <= this.digits; i++) {
      this.list.push(i)
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../../variables.scss";
</style>
